import {useTranslation} from "react-i18next";
import {useState} from "react";
import {useNavigate} from "react-router-dom";
/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 */

export const ChooseAFormModalApp =()=> {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [formSelected, setFormSelected] = useState(null);


    /**
     * Marks the clicked card as the currently selected form.
     *
     * @param {number} index Index of the chosen entry and exit form.
     * @returns {void}
     */
    const handleSelectForm = (selected) => {
        setFormSelected(selected);
    }

    /**
     * Resets modal form information to its initial state.
     *
     * Clears:
     * - Delivery form information.
     * - Uploaded evidence files.
     * - Photo picker state.
     * - Selected form.
     *
     * @returns {void}
     */
    const handleClearFields = () =>{
        setFormSelected(null);
    }

    return{
        t,
        navigate,
        handleClearFields,
        formSelected,
        handleSelectForm
    }
}
